import { ManageSubstationFormValue } from './manage-substation.interfaces';

export function createManageSubstationFormValue(): ManageSubstationFormValue {
  return {
    station_name: '',
    station_code: '',
    scada_code: '',
    state_id: null,
    district_id: null,
    operational_status: '',
    capacity: null,
    total_capacitors: null,
    total_reactors: null,
    total_transformers: null,
    region: '',
    grid_division: '',
    logsheet: true,
    lat: '',
    long: '',
    connectivity: '',
    voltage_level_id: null,
  };
}
